import doingEdit_application_readerSetup from './doingEdit_application_readerSetup';
import doingChange_application_readerSetup from './doingChange_application_readerSetup';
import doingCreate_application_readerSetup from './doingCreate_application_readerSetup';
import doingMark_application_readerSetup from './doingMark_application_readerSetup';

export { doingEdit_application_readerSetup, doingChange_application_readerSetup, doingCreate_application_readerSetup, doingMark_application_readerSetup };
export default {
    doingEdit_application_readerSetup,
    doingChange_application_readerSetup,
    doingCreate_application_readerSetup,
    doingMark_application_readerSetup
};
